import {
  addressesMatch,
  formatStreetAddress,
  formatFullAddress
} from './address.js';

export class Address {
  constructor(data) {
    this._data = {
      id: '',
      streetNumber: '',
      street: '',
      unit: '',
      city: '',
      state: '',
      zipCode: '',
      latlng: null,
      label: '',
      ...data
    };
  }

  serialize() {
    let data = { ...this._data };
    if (data.latlng) {
      if (typeof data.latlng.lat === 'function') {
        data.latlng = {
          lat: data.latlng.lat(),
          lng: data.latlng.lng()
        };
      }
    }
    return data;
  }

  get id() {
    return this._data.id;
  }

  get streetNumber() {
    return this._data.streetNumber;
  }

  get street() {
    return this._data.street;
  }

  get unit() {
    return this._data.unit;
  }

  get latlng() {
    let latlng = this._data.latlng;
    if (latlng) {
      if (typeof latlng.lat === 'function') {
        return {
          lat: latlng.lat(),
          lng: latlng.lng()
        };
      }
    }
    return latlng;
  }

  isMatch(address, lenient) {
    return addressesMatch(this._data, address, { lenient });
  }

  format() {
    return formatFullAddress(this._data);
  }

  formatStreet(includeUnit = true) {
    return formatStreetAddress(this._data, { includeUnit });
  }
}
